<template>
  <i-modal :title="LANG.focusPoint">
    <ModalFocusPointContent ref="focusPoint" :document="document"/>

    <template #footer>
      <i-button variant="secondary" @click.prevent="$emit('update:show', false)">{{ LANG.cancel }}</i-button>
      <i-button variant="primary" @click.prevent="confirm">{{ LANG.save }}</i-button>
    </template>
  </i-modal>
</template>

<script>
import { mapState } from 'vuex';
import ModalFocusPointContent from './ModalFocusPointContent.vue';

export default {
  components: {
    ModalFocusPointContent,
  },
  props: {
    document: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['LANG']),
  },
  methods: {
    confirm() {
      this.$refs.focusPoint.saveFocusPoint();
      this.$emit('update:show', false);
    },
  },
};
</script>
